import { Button, Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { dentalIcons } from "../../utils-icons/dentalIcons";

const CustomPrimaryButton = ({
  title = "Submit Case",
  isLoading = false,
  onClick,
  type,
  width = 160,
  icon,
  leadingIcon = false,
  isDisbale = false,
  isPm = false,
  isRound = false,
  isHeight = false,
  fontSize = 16,
}) => {
  if (type === "submit") {
    return (
      <Button
        htmlType={type}
        style={{
          backgroundColor: "#20C3FF",
          height: isHeight ? 38 : 43,
          borderRadius: 5,
          minWidth: width,
          color: "white",
          fontSize: 16,
          fontFamily: "Poppins-Medium",
          cursor: "pointer",
        }}
        // onClick={onClick}
      >
        {isLoading ? (
          <Spin
            indicator={<LoadingOutlined spin />}
            size="large"
            style={{ color: "white" }}
          />
        ) : (
          title
        )}
      </Button>
    );
  } else {
    return (
      <Button
        disabled={isDisbale}
        style={{
          backgroundColor: isPm
            ? "#FB5858"
            : isDisbale
            ? "#939798ff"
            : "#20C3FF",
          height: isHeight ? 36 : 43,
          borderRadius: isRound ? 8 : 5,
          minWidth: width,
          color: "white",
          fontSize: fontSize,
          fontFamily: "Poppins-Medium",
          cursor: isDisbale ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={onClick}
      >
        {leadingIcon && icon && <img src={icon} style={{ marginRight: 10 }} />}
        {isLoading ? (
          <Spin
            indicator={<LoadingOutlined spin />}
            size="large"
            style={{ color: "white" }}
          />
        ) : (
          title
        )}
        {!leadingIcon && icon && (
          <img src={icon} style={{ marginLeft: 10, marginBottom: 3 }} />
        )}
      </Button>
    );
  }
};

export default CustomPrimaryButton;
